var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Mixins
import { Component, Mixins } from 'vue-property-decorator';
import LayoutMixin from '@/mixins/layout-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
// Dependency Injection
import { container } from '@/dependency-injection/';
// Components
import BaseSetupLayout from '@/components/base/BaseSetupLayout.vue';
import DeletePromptDialog from '@/components/shared/DeletePromptDialog.vue';
import PromptDialog from '@/components/shared/PromptDialog.vue';
import FloatingActionButton from '@/components/shared/FloatingActionButton.vue';
// Vuex Store
import { useStore } from 'vuex-simple';
import ItemsMixin from '@/mixins/items-mixin';
var BaseManagementPage = /** @class */ (function (_super) {
    __extends(BaseManagementPage, _super);
    function BaseManagementPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        _this.service = {};
        _this.serviceSymbol = Symbol('');
        return _this;
    }
    Object.defineProperty(BaseManagementPage.prototype, "loading", {
        get: function () {
            return this.store.loading;
        },
        set: function (loading) {
            this.store.setLoading(loading);
        },
        enumerable: false,
        configurable: true
    });
    BaseManagementPage.prototype.openCrudSidesheet = function (mode) {
        var _this = this;
        if (mode === void 0) { mode = 'create'; }
        this.store.setLoading(true);
        if (this.store.managementPage.filterSidesheetVisible) {
            this.store.managementPage.closeFilterSidesheet();
        }
        this.$nextTick(function () {
            _this.store.managementPage.openCrudSidesheet({
                item: _this.service.getDefault(),
                mode: mode,
            });
            _this.store.setLoading(false);
        });
    };
    Object.defineProperty(BaseManagementPage.prototype, "sidesheetVisible", {
        get: function () {
            return this.store.managementPage.filterSidesheetVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseManagementPage.prototype, "sidesheetMode", {
        get: function () {
            return this.store.managementPage.crudSidesheetMode;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @function expandByDefault
     * @description Force the view to expand if not already expanded
     * @return {void}
     */
    BaseManagementPage.prototype.expandByDefault = function () {
        if (this.fluid === false) {
            this.toggleFluidLayout();
        }
    };
    /**
     * Set the default table sorting
     * @param sortBy Column name to sort by, or list of columns
     * @param descending Sort by descending, or list of booleans
     */
    BaseManagementPage.prototype.setDefaultSort = function (sortBy, sortDesc) {
        // update vuex module with new values
        this.store.items.setTableOptionsSort({ sortBy: sortBy, sortDesc: sortDesc });
    };
    /**
     * Reset filters
     */
    BaseManagementPage.prototype.beforeMount = function () {
        try {
            this.store.managementPage.closeFilterSidesheet();
            this.store.items.setIncludeDeletedFilter(false);
        }
        catch (error) {
            console.error(error);
        }
    };
    BaseManagementPage.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            var readonly, validationRules, items, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        if (!!this.serviceSymbol) return [3 /*break*/, 1];
                        // tslint:disable-next-line:max-line-length
                        console.error('No service symbol set in inherited class - e.g. public beforeMount() { this.serviceSymbol = TYPES.SupplierService; }');
                        return [3 /*break*/, 4];
                    case 1:
                        // clear out items
                        this.store.items.setItems([]);
                        this.store.managementPage.closeCrudSidesheet();
                        this.store.managementPage.closeFilterSidesheet();
                        // loading
                        this.store.setLoading(true);
                        // service
                        this.service = container.get(this.serviceSymbol);
                        return [4 /*yield*/, this.service.canEditPage(this.$route.meta.authorize)];
                    case 2:
                        readonly = (_a.sent()) ===
                            false;
                        this.store.managementPage.setReadonly(readonly);
                        validationRules = this.service.getValidationRules();
                        this.store.managementPage.setValidationRules(validationRules);
                        return [4 /*yield*/, this.getAll()];
                    case 3:
                        items = _a.sent();
                        this.store.items.setItems(items);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.store.setLoading(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    BaseManagementPage.prototype.getAll = function () {
        return __awaiter(this, void 0, Promise, function () {
            var responseMessage, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.service.getAll()];
                    case 1:
                        responseMessage = _a.sent();
                        // if not succesful, show validation message
                        if (responseMessage.success === false) {
                            this.showSnackbar({ text: responseMessage.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        // set the local items
                        return [2 /*return*/, responseMessage.data];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({ text: 'Unable to get data', color: 'error' });
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BaseManagementPage.prototype, "step", {
        /**
         * Get the step
         */
        get: function () {
            return this.store.steppedPage.step;
        },
        /**
         * Set the step
         */
        set: function (data) {
            this.store.steppedPage.setStep(data);
        },
        enumerable: false,
        configurable: true
    });
    BaseManagementPage = __decorate([
        Component({
            components: {
                'base-setup-layout': BaseSetupLayout,
                'delete-prompt-dialog': DeletePromptDialog,
                'prompt-dialog': PromptDialog,
                'floating-action-button': FloatingActionButton,
            },
        })
    ], BaseManagementPage);
    return BaseManagementPage;
}(Mixins(LayoutMixin, SnackbarMixin, ItemsMixin)));
export default BaseManagementPage;
